// extracted by mini-css-extract-plugin
export default {"text":"ModalPaidBeforeVisitRequired_text__T64rF"};